import { createContext, useContext } from 'react';
import { useWasm } from '../hooks/useWasm';

const WasmContext = createContext(null);

/**
 * Provider component that wraps the app and provides WASM instance
 */
export function WasmProvider({ children }) {
  const wasm = useWasm();

  return (
    <WasmContext.Provider value={wasm}>
      {children}
    </WasmContext.Provider>
  );
}

/**
 * Custom hook to access WASM context
 * @returns {Object} WASM context value
 */
export function useWasmContext() {
  const context = useContext(WasmContext);
  if (context === null) {
    throw new Error('useWasmContext must be used within a WasmProvider');
  }
  return context;
}

export default WasmContext;

